import React from 'react';
import { FlagIcon, FlameIcon, UsersIcon, MessageSquareIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './ui/SectionHeading';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
const benefits = [{
  icon: FlagIcon,
  title: 'Recetas argentinas',
  text: 'Sabores clásicos y opciones premium inspiradas en la cocina argentina.'
}, {
  icon: FlameIcon,
  title: 'Horneadas del día',
  text: 'Masa dorada, rellenos generosos y sabor casero.'
}, {
  icon: UsersIcon,
  title: 'Ideales para compartir',
  text: 'Perfectas para casa, reuniones, oficina o eventos pequeños.'
}, {
  icon: MessageSquareIcon,
  title: 'Pedido fácil',
  text: 'Todo directo por WhatsApp, sin formularios ni pasos extra.'
}];
export function Benefits() {
  return <section className="w-full bg-night-900 px-4 py-16 sm:px-6 sm:py-20" data-id="element-25" data-mp="1fyt8pnnyxbd0">
      <div className="mx-auto w-full max-w-6xl" data-id="element-26" data-mp="1b1j8dcz1jfae">
        <SectionHeading title="Por qué elegir Blue & White" tone="dark" data-id="element-27" data-mp="1ayonjkc47sgg" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-28" data-mp="2pwklvkn1rnm">
          {benefits.map(({
          icon: Icon,
          title,
          text
        }) => <div key={title} className="h-full rounded-2xl border border-white/10 bg-night-800 p-5" data-id="element-29" data-mp="3oyo0e7uj9fdi">
              <Icon className="h-5 w-5 text-aqua-400" aria-hidden="true" data-id="element-30" data-mp="3tyafynxu37ph" />
              <h3 className="mt-3 font-display text-[16px] uppercase tracking-wide text-white" data-id="element-31" data-mp="lhfkvuna2rly">
                {title}
              </h3>
              <p className="mt-1.5 text-[13px] leading-relaxed text-white/60" data-id="element-32" data-mp="qfz961pcgfhh">
                {text}
              </p>
            </div>)}
        </div>

        <div className="mt-9 flex justify-center" data-id="element-33" data-mp="gq7aava7p077">
          <CtaButton href={WHATSAPP_ORDER_LINK} track="whatsapp-info-click" data-id="element-34" data-mp="gowb78rpogmf">
            Pedir por WhatsApp
          </CtaButton>
        </div>
      </div>
    </section>;
}